import { WithWorkspaceId } from '~/types/common';
import { Artifact } from '~/types/resources';
import { taskDataApi } from '~/utils/api';

export const deleteArtifacts = async ({
  workspaceId,
  stepRunId,
}: { stepRunId: string } & WithWorkspaceId) =>
  taskDataApi.delete<Artifact[]>(`/workspaces/${workspaceId}/runs/${stepRunId}/artifacts`);

export const deleteArtifact = async ({
  workspaceId,
  stepRunId,
  artifactId,
}: { stepRunId: string; artifactId: string } & WithWorkspaceId) =>
  taskDataApi.delete<Artifact>(
    `/workspaces/${workspaceId}/runs/${stepRunId}/artifacts/${artifactId}`,
  );
